import {
  Block,
  NumberBlock,
  StringBlock,
  BooleanBlock,
  Variable,
  Action,
} from "./index";
import {STATE, GRAMMAR} from "../Type";

export class Operator extends Block {
  get type() {
    return "Operator";
  }

  get category() {
    return "Operator";
  }

  getGrammarFor() {
    return GRAMMAR.OBJECTIVE;
  }

  getDefaultChildren() {
    if (this.data === "!") {
      return [new Block({state: STATE.INSTANCE, parent: this})];
    } else {
      return [
        new Block({state: STATE.INSTANCE, parent: this}),
        new Block({state: STATE.INSTANCE, parent: this}),
      ];
    }
  }

  static getPrototypeBlocks() {
    return [
      new Operator({data: "+", state: STATE.PROTOTYPE}),
      new Operator({data: "-", state: STATE.PROTOTYPE}),
      new Operator({data: "/", state: STATE.PROTOTYPE}),
      new Operator({data: "*", state: STATE.PROTOTYPE}),
      new Operator({data: "%", state: STATE.PROTOTYPE}),
      new Operator({data: ">", state: STATE.PROTOTYPE}),
      new Operator({data: ">=", state: STATE.PROTOTYPE}),
      new Operator({data: "==", state: STATE.PROTOTYPE}),
      new Operator({data: "<=", state: STATE.PROTOTYPE}),
      new Operator({data: "<", state: STATE.PROTOTYPE}),
      new Operator({data: "&&", state: STATE.PROTOTYPE}),
      new Operator({data: "||", state: STATE.PROTOTYPE}),
      new Operator({data: "!", state: STATE.PROTOTYPE}),
    ];
  }

  getAvailableChildTypesAt() {
    switch (this.data) {
      case "-":
      case "/":
      case "*":
      case "%":
        return [NumberBlock, Variable];
      case "+":
        if (this.parent instanceof Action) {
          const childIndex = this.parent.children.indexOf(this);
          return this.parent.getAvailableChildTypesAt(childIndex);
        } else {
          return [NumberBlock, Variable];
        }
      case ">":
      case ">=":
      case "<=":
      case "<":
        return [NumberBlock, Variable];
      case "==":
        return [NumberBlock, StringBlock, BooleanBlock, Variable];
      case "&&":
      case "||":
      case "!":
        return [BooleanBlock, Variable];
      default:
        return [];
    }
  }

  getOperatorTypes() {
    switch (this.data) {
      case "-":
      case "/":
      case "*":
      case "%":
        return [NumberBlock];
      case "+":
        return [NumberBlock, StringBlock];
      case ">":
      case ">=":
      case "==":
      case "<=":
      case "<":
        return [BooleanBlock];
      case "&&":
      case "||":
      case "!":
        return [BooleanBlock];
      default:
        return [];
    }
  }

  toJavascript() {
    if (this.data === "!") {
      const operator = this.data;
      const flag = this.children[0].toJavascript();
      return `${operator}${flag}`;
    } else {
      const operator = this.data;
      const prev = this.children[0].toJavascript();
      const next = this.children[1].toJavascript();
      return `${prev} ${operator} ${next}`;
    }
  }
}
